import type * as React from 'react';
import { Box } from 'ui';

export const NavGrid = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={(theme) => ({
        display: 'grid',
        gridGap: theme.spacing(2),
        gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
      })}
    >
      {children}
    </Box>
  );
};
